import React, { useEffect, useState } from 'react'
import { BookingService } from '../Service'
import Swal from 'sweetalert2';
import { Autocomplete, Box, Button, Card, Checkbox, CircularProgress, Divider, Grid, IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Add, Delete, Remove } from '@mui/icons-material';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const AddNewService = (props) => {
  const {providerId,bookingItems,handleAddNewServices} = props;
  const {control,watch,setValue,handleSubmit} = useForm();
  const [categoryList, setCategoryList] = useState([]);  
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [serviceMasterList, setServiceMasterList] = useState([]);
  const [isFetchingList, setIsFetchingList] = useState(false);
  const fetchProviderServices = async () => {
    setIsFetchingList(true);
    const response = await BookingService.fetchProviderServices(providerId);
    if(response.success == '1'){
      setCategoryList(response.data);
    }else if(response.success == '0'){
      Swal.fire("Error", response.message, "error");
    }
    setIsFetchingList(false);
  }
  useEffect(() => {
    if(providerId){
      fetchProviderServices();
    }
  }, [providerId])
  const categoryId = watch('categoryId');
  useEffect(() => {
    if(categoryId){
      const selectedCategory = categoryList.find(cat => cat.id === categoryId);
      if(selectedCategory){
        setSubCategoryList(selectedCategory.subCat || []);
      }else{
        setSubCategoryList([]);
      }
    }
  }, [categoryId])
  const subCategoryId = watch('subCategoryId');
  useEffect(() => {
    
    if(subCategoryId){
      const selectedSubCategory = subCategoryList.find(subCat => subCat.id === subCategoryId);
      if(selectedSubCategory){
        // group all ps for selected subcategory
        let ps = [];
        selectedSubCategory.servCat.forEach(serviceItem => {
          // serviceItem has ServicesMaster object with childServices array
          serviceItem.ServicesMaster.childServices.forEach(childService => {
            
            //  exclude already added services in bookingItems p.id not equal to bookingitem.providerServiceId
            childService.pS.forEach(p =>{
              if(!bookingItems?.some(bookingItem => bookingItem.providerServiceId === p.id)){
                ps.push({
                  title:childService.title,
                  providerServiceId:p.id,
                  serviceTime:p.serviceTime,
                  price:p.price,
                  masterSerViceId:serviceItem.servicesMasterId,
                  masterSerViceTitle:serviceItem.ServicesMaster.title,
                  childServiceId:childService.id,
                  childServiceTitle:childService.title,
                  brand:p.brd,
                })
              }
            })
          })
        })
        console.log("ps", ps);

        setServiceMasterList(ps || []);
      }else{
        setServiceMasterList([]);
      }
    }
  }, [subCategoryId, subCategoryList])
  const services = watch('services') || [];
  const handleQuantityChange = (id, quantity) => {
        const items = services.map(service => 
            service.providerServiceId === id ? { ...service, quantity: parseInt(quantity) || 0,serviceTime:(service.serviceTime/service.quantity)* parseInt(quantity) || 0} : service
        );
        setValue('services',items,{
            shouldDirty: true,
            shouldTouch: true
        });
    };


    const handleDeleteService = (id) => {
        const updatedServices = services.filter(service => service.providerServiceId !== id);
        // setSelectedServices(updatedServices);
        setValue('services', updatedServices); // Update the form value
    };

    const handleFormSubmit = (data) => {
        console.log("Selected Services Data:", data);
        const modifiedData = data.services.map(service=>{
          return {
            id:0,
            providerServiceId:service.providerServiceId,
            quantity:0,
            newQuantity:service.quantity
          }
        })
        handleAddNewServices(modifiedData);        
    }
  return (
    <Box component={'form'} onSubmit={handleSubmit(handleFormSubmit)}>
      <Grid container spacing={2} >
                      {/* ............left section................... */}
          <Grid item xs={12} lg={5}>
              <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:(!categoryList.length > 0)&&'lightGray'}}>Select Category<span style={{color:(!categoryList.length > 0)?'lightGray':'#d32f2f'}}>*</span></Typography>
              <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                  <Controller
                      name='categoryId'
                      control={control}
                      rules={{required:'select category'}}
                      render={({field,fieldState:{error}})=>(
                          <Autocomplete
                              fullWidth
                              {...field}
                              disabled={!categoryList.length > 0}
                              options={categoryList|| []}
                              getOptionLabel={(option) => option?.title || ''}
                              isOptionEqualToValue={(option, value) =>
                                  option.id === (value?.id || value)
                              }
                              onChange={(event, newValue) => {
                                  field.onChange(newValue ? newValue.id : null);
                              }}
                              value={categoryList.find(option => option.id === field.value) || null}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      // label="Select SAC Code*"
                                      placeholder='Search and Select Category'
                                      error={!!error}
                                      // helperText={error ? error.message : ''}
                                      size="small"
                                      inputProps={{
                                          ...params.inputProps,
                                          style: { fontSize: '0.75rem' }
                                      }}
                                  />
                              )}
                              renderOption={(props, option) => (
                                  <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                  {option.title || ''}
                                  </MenuItem>
                              )}
                          />
                      )}  
                  />
                  {isFetchingList && <CircularProgress/>}
              </Box>
          </Grid>
          <Grid item xs={0} lg={2}/>
          <Grid item xs={12} lg={5}>
              <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!categoryId && 'lightGray'}}>Select Sub-Category<span style={{color:!categoryId?'lightGray':'#d32f2f'}}>*</span></Typography>
              <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                  <Controller
                      name='subCategoryId'
                      control={control}
                      rules={{required:'select sub-category'}}
                      render={({field,fieldState:{error}})=>(
                          <Autocomplete
                              fullWidth
                              {...field}
                              disabled={!categoryId}
                              options={subCategoryList|| []}
                              getOptionLabel={(option) => option?.title || ''}
                              isOptionEqualToValue={(option, value) =>
                                  option.id === (value?.id || value)
                              }
                              onChange={(event, newValue) => {
                                  field.onChange(newValue ? newValue.id : null);
                              }}
                              value={subCategoryList.find(option => option.id === field.value) || null}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      // label="Select SAC Code*"
                                      placeholder='Search and Select Sub-Category'
                                      error={!!error}
                                      // helperText={error ? error.message : ''}
                                      size="small"
                                      inputProps={{
                                          ...params.inputProps,
                                          style: { fontSize: '0.75rem' }
                                      }}
                                  />
                              )}
                              renderOption={(props, option) => (
                                  <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                      {option.title || ''}
                                  </MenuItem>
                              )}
                          />
                      )}  
                  />
              </Box>
          </Grid>
          
      </Grid>
      <Divider sx={{my:'2%',borderBlockStyle:'dashed',borderBlockWidth:'1px'}}/>
      
      <Grid container spacing={2} >
          <Grid item xs={12} lg={5}>
              <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!serviceMasterList.length > 0 && 'lightGray'}}>Select Services<span style={{color:!serviceMasterList.length > 0 ? 'lightGray': '#d32f2f'}}>*</span></Typography>
              <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                  <Controller
                      name='services'
                      control={control}
                      rules={{ required: 'Select service' }}
                      render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                          fullWidth
                          {...field}
                          multiple
                          disabled={!serviceMasterList.length > 0}
                          disableCloseOnSelect
                          options={serviceMasterList}
                          getOptionLabel={(option) => option.title}
                          renderOption={(props, option, { selected }) => (
                          <li {...props} key={option.providerServiceId} style={{fontSize:'0.75rem'}} > 
                              <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              />
                              <Typography sx={{fontSize:'.65rem'}}>{option?.title}{option.brand?.id !='1' && <Box component={'span'} sx={{color:'#1565c0'}}>_{option.brand?.title}</Box>}</Typography>
                              
                              {/* {option.title} */}
                          </li>
                          )}
                          renderInput={(params) => (
                          <TextField
                              {...params}
                              InputProps={{
                              ...params.InputProps,
                              style: { fontSize: '0.75rem',color:'#000' },
                              }}
                              size='small'
                              error={!!error}
                              variant="outlined"
                              placeholder="Select services"
                          />
                          )}
                          onChange={(_, newValue) => {
                          const servicesWithQuantity = newValue.map(service => ({
                              ...service,
                              quantity: service.quantity || 1
                          }));
                          field.onChange(servicesWithQuantity);
                          }}
                          value={field.value || []}
                          isOptionEqualToValue={(option, value) => option.providerServiceId === value.providerServiceId}
                      />
                      )}
                  />
                  {/* {loadingServiceList && <CircularProgress />} */}
              </Box>
          </Grid>
          <Grid item xs={12} sx={{display:services.length>0?'block':'none'}}>
              <Box>
                  <Typography sx={{fontWeight:'600',color:'#494949'}}>Selected Services</Typography>
                  <Card sx={{bgcolor:'#dadada4d'}}>
                      <Grid container>
                          <Grid item xs={12}>
                              {/* <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',borderBottom:'1px solid #BEC2C2'}}>
                                  <Typography sx={{fontWeight:500,color:'#3E3E3E'}}>New Booking Items </Typography>
                                  <Typography sx={{fontWeight:500,fontSize:'small',color:'#3E3E3E'}}>{services.length>0? services.length:''} Services</Typography>
                              </Box> */}
                              <Box>
                                  <TableContainer component={Paper}>
                                      <Table>
                                          <TableHead>
                                              <TableRow>
                                                  <TableCell sx={{fontWeight:600,p:'1% 2%'}} width="40%" >Service</TableCell>
                                                  <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Quantity</TableCell>
                                                  <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Time</TableCell>
                                                  <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Price</TableCell>
                                                  <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Total</TableCell>
                                                  <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="right" width="12%" >Action</TableCell>
                                              </TableRow>
                                          </TableHead>
                                          <TableBody>
                                              {services.map((service) => (
                                              <TableRow key={service.providerServiceId}>
                                                  <TableCell sx={{ p: 1 }}>{service.title}</TableCell>
                                                  <TableCell align="center" sx={{ p: 1 }}>
                                                      <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                          <IconButton
                                                          size="small"
                                                          onClick={() => handleQuantityChange(service.providerServiceId, Math.max(1, service.quantity - 1))}
                                                          >
                                                          <Remove sx={{color:'#1A44B8'}} fontSize='small'/>
                                                          </IconButton>
                                                          
                                                          <TextField
                                                          type="number"
                                                          value={service.quantity}
                                                          onChange={(e) =>{
                                                              if(e.target.value<1){
                                                              e.target.value=1;
                                                              }
                                                              handleQuantityChange(service.providerServiceId, e.target.value)
                                                          } }
                                                          inputProps={{ 
                                                              min: 1,
                                                              style: { 
                                                              textAlign: 'center', 
                                                              width: '2em',
                                                              '-moz-appearance': 'textfield',
                                                              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                                  '-webkit-appearance': 'none',
                                                                  margin: 0
                                                              }
                                                              } 
                                                          }}
                                                          size="small"
                                                          variant="standard"
                                                          sx={{ 
                                                              mx: 1,
                                                              "& .MuiInput-underline:before": { borderBottom: "none" },
                                                              "& .MuiInput-underline:after": { borderBottom: "none" },
                                                              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                              borderBottom: "none"
                                                              },
                                                              "& .MuiInputBase-input": {
                                                              borderLeft: "1px solid #ccc",
                                                              borderRight: "1px solid #ccc",
                                                              px: 0 
                                                              }
                                                          }}
                                                          />

                                                          <IconButton
                                                          size="small"
                                                          onClick={() => handleQuantityChange(service.providerServiceId, service.quantity + 1)}
                                                          >
                                                          <Add fontSize='small' sx={{color:'#1A44B8'}}/>
                                                          </IconButton>
                                                      </Paper>
                                                  </TableCell>
                                                  <TableCell align="center" sx={{ p: 1 }}>
                                                      {service.serviceTime} mins
                                                  </TableCell>
                                                  <TableCell sx={{ p: 1 ,textAlign:'center'}}>₹{service.price}</TableCell>                                                                       
                                                  <TableCell sx={{ p: 1 ,textAlign:'center'}} >₹{parseFloat(service.price*service.quantity).toFixed(2)}</TableCell>
                                                  <TableCell align="right" sx={{ p: 1 }}>
                                                      <IconButton
                                                          aria-label="delete"
                                                          onClick={() => handleDeleteService(service.providerServiceId)}
                                                          size="small"
                                                          color='error'
                                                      >
                                                          <Delete />
                                                      </IconButton>
                                                  </TableCell>
                                              </TableRow>
                                              ))}
                                              {/* <TableRow sx={{P:0}}>
                                                  <TableCell rowSpan={'2'} colSpan={2}/>
                                                  <TableCell  sx={{textAlign:'right', fontWeight:'600',borderBottom:'none',p:1}} colSpan={2}>SubTotal:</TableCell>
                                                  <TableCell sx={{textAlign:'right',borderBottom:'none',p:1}}>₹{billCalculations.subTotal}</TableCell>
                                              </TableRow> */}
                                              
                                              {/* <TableRow sx={{borderBottom:'1px solid lightGray'}}>
                                              <TableCell  
                                                  sx={{
                                                  textAlign:'right',
                                                  p:1
                                                  }} 
                                                  colSpan={2}
                                              >
                                                  Visiting Charge:
                                              </TableCell>
                                              <TableCell 
                                                  sx={{
                                                  textAlign:'right',
                                                  p:1
                                                  }}
                                              >
                                                  ₹{parseFloat(billCalculations.subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(chargeDetails?.vistingCharge).toFixed(2)}
                                              </TableCell>
                                              </TableRow>                           */}
                                              
                                              {/* <TableRow>
                                                  <TableCell colSpan={4} sx={{
                                                      textAlign:'right', 
                                                      fontWeight:'600',
                                                      borderBottom: 'none',p:1
                                                  }}>Total:</TableCell>
                                                  <TableCell sx={{
                                                      textAlign:'right',
                                                      fontWeight:'600',
                                                      borderBottom: 'none',p:1
                                                  }}>
                                                      ₹{parseFloat(billCalculations.total).toFixed(2)}
                                                  </TableCell>
                                              </TableRow> */}
                                          </TableBody>
                                      </Table>
                                      {/* <Box sx={{p:'1%'}}>
                                          <Typography sx={{width:'100%',fontSize:'0.75rem',color:'#3e3e3e'}}>
                                              {billCalculations.remainingAmounttoWaiveVisitingCharge>0 && `Add more items worth ₹${billCalculations.remainingAmounttoWaiveVisitingCharge} to waive visiting charge`}
                                          </Typography>
                                      </Box> */}
                                  </TableContainer>
                              </Box>
                          </Grid>
                      </Grid>
                  </Card>
              </Box>
          </Grid>
          <Grid item xs={12} sx={{textAlign:'center'}}>
          <Button variant='contained' color='primary' size='small' type='submit' sx={{textTransform:'capitalize'}} >
            Add Selected Services
          </Button>
          </Grid>
      </Grid>
    </Box>
  )
}

export default AddNewService
